import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Mail, Phone, MapPin } from 'lucide-react';
import { logoUrl } from '../data/mock';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img src={logoUrl} alt="Space Data" className="h-12 w-12 object-contain" />
              <span className="text-2xl font-bold">Space Data</span>
            </div>
            <p className="text-gray-400 leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t.footer.services}</h3>
            <ul className="space-y-2">
              {t.services.items.slice(0, 4).map((service, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection('services')}
                    className="text-gray-400 hover:text-orange-500 transition-colors"
                  >
                    {service.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t.footer.company}</h3>
            <ul className="space-y-2">
              {t.footer.companyLinks.map((link, index) => (
                <li key={index}>
                  <button className="text-gray-400 hover:text-orange-500 transition-colors">
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">{t.footer.contact}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400">{t.footer.address}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
                <a href={`mailto:${t.footer.email}`} className="text-gray-400 hover:text-orange-500 transition-colors">
                  {t.footer.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" />
                <a href={`tel:${t.footer.phone}`} className="text-gray-400 hover:text-orange-500 transition-colors">
                  {t.footer.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              © {currentYear} Space Data. {t.footer.rights}
            </p>
            <div className="flex items-center space-x-6">
              <button className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                Privacy Policy
              </button>
              <button className="text-gray-400 hover:text-orange-500 transition-colors text-sm">
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
